<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   width="24"
   height="24"
   viewBox="0 0 24 24"
   fill="none"
   version="1.1"
   id="svg3"
   sodipodi:docname="channel.svg"
   inkscape:version="1.3.2 (091e20ef0f, 2023-11-25, custom)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs3" />
  <sodipodi:namedview
     id="namedview3"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:zoom="30.708333"
     inkscape:cx="12.016282"
     inkscape:cy="12.016282"
     inkscape:window-width="1916"
     inkscape:window-height="1036"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="0"
     inkscape:current-layer="svg3" />
  <path
     d="M 3.741177,7.45 H 20.25885 C 21.09027,7.45 21.9,8.214145 21.9,9.331819 V 19.06819 C 21.9,20.1859 21.09027,20.95 20.25885,20.95 H 3.741177 C 2.909694,20.95 2.1,20.1859 2.1,19.06819 V 9.331819 C 2.1,8.214145 2.909694,7.45 3.741177,7.45 Z"
     stroke="currentColor"
     stroke-width="1.8"
     id="path1" />
  <path
     d="M 6.6,2.05 11.1,7"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     stroke-linejoin="round"
     id="path2" />
  <path
     d="M 17.4,2.05 12.9,7"
     stroke="currentColor"
     stroke-width="1.8"
     stroke-linecap="round"
     stroke-linejoin="round"
     id="path3" />
</svg>
